// @flow
import styled from 'styled-components';
import DefaultTheme from '.';
import { sd300 } from '../../../colors';
/*::
import type { ItemThemeType } from '.';
*/

var theme
/*: ItemThemeType */
= Object.assign({}, DefaultTheme, {
  CheckBox: styled(DefaultTheme.CheckBox).attrs({
    color: sd300()
  }).withConfig({
    displayName: "shipa-delivery__CheckBox",
    componentId: "jthg3l-0"
  })([""])
});
export default theme;